// Phase 18 Plan 06 — POLISH-11 Typeface segmented pill.
//
// Two values: 'system' (Manrope default) / 'opendyslexic'. Wired to the
// $typography persistent atom; RootApp mirrors the chosen value onto
// documentElement.dataset.typography. globals.css [data-typography=
// "opendyslexic"] swaps --font-family-body to OpenDyslexic with Manrope
// fallback (UI-SPEC §Error state — silent fallback if binaries fail to load).

import { useStore } from '@nanostores/react'
import type { JSX } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { $typography, type Typography } from '../../stores/typography.js'
import { Seg } from '../components/Seg.js'

export function TypographyToggle(): JSX.Element {
  const value = useStore($typography)
  const intl = useIntl()
  const groupLabel = intl.formatMessage({
    id: 'settings.typography.label',
    defaultMessage: 'Typeface',
  })
  return (
    <fieldset
      data-testid="typography-toggle"
      aria-label={groupLabel}
      className="picker-row"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%',
        border: 'none',
        margin: 0,
        padding: 0,
      }}
    >
      <legend
        style={{
          fontFamily: 'Fredoka, sans-serif',
          fontWeight: 700,
          fontSize: '16px',
          color: 'var(--color-text-primary)',
          padding: 0,
          marginBottom: '4px',
        }}
      >
        <FormattedMessage
          id="settings.typography.label"
          defaultMessage="Typeface"
        />
      </legend>
      <Seg<Typography>
        ariaLabel={groupLabel}
        value={value}
        onChange={(next) => $typography.set(next)}
        options={[
          {
            value: 'system',
            label: (
              <FormattedMessage
                id="settings.typography.opt.system"
                defaultMessage="System"
              />
            ),
          },
          {
            value: 'opendyslexic',
            label: (
              <FormattedMessage
                id="settings.typography.opt.opendyslexic"
                defaultMessage="OpenDyslexic"
              />
            ),
          },
        ]}
      />
    </fieldset>
  )
}
